import { cn } from "@/lib/utils";

/**
 * A long single-line value, clipped with an ellipsis and readable in full on
 * hover.
 *
 * The truncation is CSS only, so the whole string stays in the DOM — a screen
 * reader still reads every word of it, and no ARIA is needed. `title` is for
 * the sighted mouse user, who is the only one the clipping actually costs.
 * A tooltip would be worse here: it needs a focusable trigger, which turns a
 * static label into a tab stop that does nothing when activated, and it would
 * have the name announced twice.
 *
 * `min-w-0` is what lets the ellipsis appear at all inside a flex row; without
 * it the text pushes the row wider instead of clipping.
 */
export const HcbbTruncatedText = ({
  text,
  className,
}: {
  text: string;
  className?: string;
}) => (
  <span title={text} className={cn("block min-w-0 truncate", className)}>
    {text}
  </span>
);
